declare global {
    interface RouterMeta {
        title?: string;
        level?: number;
        keepAlive?: boolean;
        keepAliveFromRoutes?: Array<string> | null;
        keepAliveRoutes?: Array<string> | null;
    }

    interface Router {
        path: string;
        name: string;
        icon?: string;
        props?: boolean; //是否作为属性注入
        permission?: string;
        meta?: RouterMeta;
        component: any;
        children?: Array<Router>;
    }

    interface System {
        import(request: string): Promise<any>
    }

    var System: System
}
import home from '../views/home/home.vue'
import main from '../views/main.vue'
import attachment from '../views/common/attachmentViewer.vue'


export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => import('../components/lockscreen/components/locking-page.vue')
};
export const loginRouter: Router = {
    props: true,
    path: '/login/:isWx?',
    name: 'login',
    meta: {
        title: 'LogIn'
    },
    component: () => import('../views/login/index.vue')
};

// export const redirect: Router = {
//     path: '/redirect',
//     name: 'redirect',
//     meta: {
//         title: 'redirect'
//     },
//     component: () => import('../views/login.vue')
// };
//

// export const attachmentRouter: Router = {
//     path: '/attachment/:viewType/:id/:fileId?/',
//     props: true,
//     name: 'attachment',
//     meta: {
//         title: 'attachment'
//     },
//     component: attachment
// };

//微信重定向api
export const wxRedirectRoute: Router = {
    path: '/wxredirect*',
    name: 'wxredirect',
    meta: {
        title: 'redirect'
    },
    component: () => import('../views/login/wxredirect.vue')
}


export const userCenter: Router = {
    path: '/user',
    name: 'user',
    meta: {
        title: 'redirect'
    },
    component: () => import('../views/usercenter/index.vue'),
    children: [
        {
            path: 'overview',
            name: 'overview',
            meta: {
                title: '用户中心',
                level: 1
            },
            component: () => import('../views/usercenter/overview.vue'),
        }, {
            path: 'userinfo',
            name: 'userinfo',
            meta: {
                title: '修改个人信息',
                level: 1
            },
            component: () => import('../views/usercenter/userinfo.vue'),
        },
        {
            path: 'myquestion',
            name: 'myquestion',
            meta: {
                title: '我的提问',
                level: 1
            },
            component: () => import('../views/usercenter/myqustion.vue'),
        },
        {
            path: 'myanswer',
            name: 'myanswer',
            meta: {
                title: '我的回答',
                level: 1
            },
            component: () => import('../views/usercenter/myanswer.vue'),
        },
        {
            path: 'myapply',
            name: 'myapply',
            meta: {
                title: '我的培训',
                level: 1
            },
            component: () => import('../views/usercenter/myapply.vue'),
        },
        {
            path: 'security',
            name: 'security',
            meta: {
                title: '安全中心',
                level: 1
            },
            component: () => import('../views/usercenter/usersecurity.vue'),
        },
        {
            path: 'mycollect',
            name: 'mycollect',
            meta: {
                title: '我的收藏',
                level: 1
            },
            component: () => import('../views/usercenter/mycollect.vue'),
        }
    ]
}


export const appRouters: Array<Router> = [
    {
        path: '/',
        name: 'home',
        meta: {
            title: '首页',
            level: 1,
        },
        component: () => import('../views/home/index.vue'),
        children: [{
            path: '/globalList',
            name: 'globalList',
            meta: {
                title: '首页',
                level: 1,
            },
            component: () => import('../views/home/globalList.vue')
        }]
    }, {
        path: '/train',
        name: 'train',
        meta: {
            title: '培训报名',
            level: 2
        },
        component: () => import('../views/train/index.vue')
    }, {
        props: true,
        path: '/trainDetail/:trainId',
        name: 'trainDetail',
        meta: {
            title: '{{pxtitle}}',
            level: 3
        },
        component: () => import('../views/train/trainDetail.vue')
    },
    {
        props: true,
        path: '/trainApply/:trainId/:trainName',
        name: 'trainApply',
        meta: {
            title: '我要报名',
            level: 4
        },
        component: () => import('../views/train/applyTrain.vue')
    },
    /*知识库*/
    {
        props: true,
        path: '/knowledgeBase/:queryParams?',
        name: 'knowledgeBase',
        meta: {
            title: '知识库',
            level: 2
        },
        component: () => import('../views/knowledgeBase/index.vue')
    },
    {
        props: true,
        path: '/knowledgeBaseDetail/:queryParams',
        name: 'knowledgeBaseDetail',
        meta: {
            title: '{{knowTitle}}',
            level: 3
        },
        component: () => import('../views/knowledgeBase/detail.vue')
    },
    /*Q&A*/
    {
        props: true,
        path: '/QA/:queryParams?',
        name: 'QA',
        meta: {
            title: 'Q&A',
            level: 2
        },
        component: () => import('../views/QA/index.vue')
    },
    {
        props: true,
        path: '/QADetail/:queryParams',
        name: 'QADetail',
        meta: {
            title: '{{QATitle}}',
            level: 3
        },
        component: () => import('../views/QA/detail.vue')
    },
    {
        props: true,
        path: '/askQuestion/:queryParams?',
        name: 'askQuestion',
        meta: {
            title: '我要提问',
            level: 2
        },
        component: () => import('../views/QA/askQuestion.vue')
    },
    /*培训报名*/
    {
        path: '/register',
        name: 'register',
        meta: {},
        component: () => import('../views/register/index.vue')
    }, {
        props: true,
        path: '/query/:keywords?',
        name: 'query',
        meta: {
            title: '搜索',
            level: 2
        },
        component: () => import('../views/query/index.vue')
    },
    {
        path: '/wxregister/',
        name: 'wxregister',
        meta: {},
        component: () => import('../views/login/wxRegister.vue')
    }
]
export const routers = [
    loginRouter,
    locking,
    wxRedirectRoute,
    userCenter,
    // attachmentRouter,
    ...appRouters,
];
